module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-left-panel-2-7d34d96640e6bdd153fe2c911e6e26de.svg";